import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import AdminLayout from 'layout/AdminLayout';
import Loadable from 'components/Loadable';
import AdminGuard from 'utils/route-guard/AdminGuard';
const Dashboard = Loadable(lazy(() => import('pages/admin/dashboard')));
const Analytics = Loadable(lazy(() => import('pages/admin/analytics')));
const AgentiveChatAnalytics = Loadable(lazy(() => import('pages/admin/agentive-chat-analytics')));
const ExperimentVariantChatAnalytics = Loadable(lazy(() => import('pages/admin/experiment-variant-chat-analytics')));
const AdminChatThreadsPage = Loadable(lazy(() => import('pages/admin/admin-chat-threads')));
const AutomationsListPage = Loadable(lazy(() => import('pages/admin/AutomationsListPage')));
const AutomationDetailPage = Loadable(lazy(() => import('pages/admin/AutomationDetailPage')));
const NotificationTestingPage = Loadable(lazy(() => import('pages/admin/NotificationTestingPage')));

const AdminRoutes = {
  path: '/rimash',
  element: (
    <AdminGuard>
      <AdminLayout />
    </AdminGuard>
  ),
  children: [
    {
      path: 'analytics',
      element: <Navigate to="/rimash/analytics/dashboard" replace />
    },
    {
      path: 'analytics/dashboard/*',
      element: <Dashboard />
    },
    {
      path: 'analytics/analytics/*',
      element: <Analytics />
    },
    {
      path: 'analytics/agentive-chat/*',
      element: <AgentiveChatAnalytics />
    },
    {
      path: 'analytics/experiment-variant-chat/*',
      element: <ExperimentVariantChatAnalytics />
    },
    {
      path: 'analytics/chat-threads',
      element: <AdminChatThreadsPage />
    },
    {
      path: 'analytics/chat-threads/:threadId',
      element: <AdminChatThreadsPage />
    },
    {
      path: 'analytics/automations',
      element: <AutomationsListPage />
    },
    {
      path: 'analytics/automations/:automationId',
      element: <AutomationDetailPage />
    },
    {
      path: 'analytics/notifications',
      element: <NotificationTestingPage />
    }
  ]
};

export default AdminRoutes;
